import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "web-design-system";
import { EllipsisVerticalIcon } from "lucide-react";
import type { SchemeFolioHolding } from "creso-core/types";

/** One entry in a holding's actions menu. */
export type HoldingActionConfig = {
  label: string;
  onClick: () => void;
  /** Left out of the menu when true. */
  hidden?: boolean;
};

/** The folio a holding row maps to — its own, or its only folio. */
export function getHoldingFolioId(holding: SchemeFolioHolding) {
  if (holding.folio_id) return holding.folio_id;
  if (holding.folio_data && holding.folio_data.length === 1)
    return holding.folio_data[0].folio_id;
  return null;
}

/**
 * Overflow menu for a holdings row. Host apps supply the entries, since what a
 * holding allows and where each action leads differ between apps.
 */
export function HoldingActionsDropdown({
  actions,
}: {
  actions: HoldingActionConfig[];
}) {
  const visibleActions = actions.filter((action) => !action.hidden);

  if (!visibleActions.length) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <EllipsisVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {visibleActions.map((action) => (
          <DropdownMenuItem key={action.label} onClick={action.onClick}>
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
